export default __webpack_public_path__ + "media/fonts/foundation-icons/foundation-icons-b97e770b0e3c6ebed11df5a56dd9d8c4.eot";